import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { warningSwal } from "Util/Toast";
import EarningClasses from "./Earning.module.css";
import Moment from "react-moment";
import { Services } from "Services";
import Skeleton from "react-loading-skeleton";
import { useNavigate, useSearchParams } from "react-router-dom";

function Earnings({ setPayoutId, setType, Type }) {
    const Navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const token = { Authorization: `token ${localStorage.getItem("token")}` };
    const [params] = useSearchParams();

    const [earning, setEarning] = useState([]);
    const get_Earnings = (ID) => {
        Services.Get_Payout_new("GET", null, token, ID)
            .then((res) => {
                console.log(res);
                setTimeout(() => {
                    setLoading(false);
                }, 300);
                if (res.Status === 1) {
                    setEarning(res.Get_Payouts);
                } else if (res.Status === 0) {
                    warningSwal("Error", res?.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                setLoading(false);
                // alert(err);
                warningSwal("Error", "Something went wrong ");
                console.log(err);
            });
    };
    useEffect(() => {
        get_Earnings(params.get("TutorId"));
    }, []);
    const detailHandler = (e) => {
        setType(2);
        setPayoutId(e.currentTarget.getAttribute("id"));
    };
    function calculateTDSandNet(grossAmount, tdsPercent) {
        const tdsAmount = grossAmount * (tdsPercent / 100);
        const netAmount = grossAmount - tdsAmount;
        return {
            tdsAmount: tdsAmount,
            netAmount: netAmount,
        };
    }
    return (
        <>
            <h3>Payouts</h3>

            {/* <p>Filter By Date</p> */}
            {/* <header>
                <form
                    className={EarningClasses["form"]}
                    onSubmit={handleSubmit(onSubmit)}>
                    <input
                        type="date"
                        max={new Date().toISOString().split("T")[0]}
                        {...register("FromDate", {
                            required: true,
                        })}
                    />
                    <input
                        type="date"
                        max={new Date().toISOString().split("T")[0]}
                        {...register("ToDate", {
                            required: true,
                        })}
                    />
                    <button>Filter</button>
                </form>
                <div>
                    <button
                        onClick={CreatePayoutHandler}
                        disabled={selectedRows.length == 0}
                        title={
                            selectedRows.length == 0
                                ? "Select Earnings to create Payout"
                                : ""
                        }>
                        Create Payout
                    </button>
                </div>
            </header> */}
            <div className={EarningClasses["Table"]} style={{ width: "65vw" }}>
                <table style={{ minWidth: "1550px", overflow: "scroll" }}>
                    <thead>
                        <tr>
                            <th>Payout ID</th>
                            <th>Payout Date</th>
                            <th>Classes</th>
                            <th>Lesson Complete</th>
                            <th>Demo Complete</th>
                            <th>Student(demo) Conversion</th>
                            <th>Penalty Charged</th>
                            <th>Penalty Waived</th>
                            <th>Manual Adj. Credit</th>
                            <th>Manual Adj. Debit</th>
                            <th>Gross amount</th>
                            <th>TDS 1%</th>
                            <th>Net amount</th>
                            <th>Payout Status</th>
                        </tr>
                    </thead>
                    {loading ? (
                        <tbody>
                            {[1, 1].map((item) => (
                                <tr className={EarningClasses["loading"]}>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                    <td>
                                        <Skeleton />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    ) : (
                        <tbody>
                            {earning?.length > 0 ? (
                                earning?.map((item) => {
                                    let { netAmount, tdsAmount } =
                                        calculateTDSandNet(item.NetAmount, 1);
                                    return (
                                        <tr
                                            onClick={detailHandler}
                                            id={item.PayoutID}>
                                            <td>{item.PayoutID}</td>
                                            <td>
                                                <Moment format="DD-MM-YYYY">
                                                    {item.PayoutDate}
                                                </Moment>
                                            </td>
                                            <td>{item?.TotalClasses}</td>
                                            <td>
                                                ₹{" "}
                                                {isNaN(
                                                    item?.LessonCompleteAmount
                                                )
                                                    ? "NA"
                                                    : Number(
                                                          item?.LessonCompleteAmount
                                                      ).toFixed(2)}
                                            </td>
                                            <td>
                                                ₹{" "}
                                                {isNaN(item?.DemoCompleteAmount)
                                                    ? "NA"
                                                    : Number(
                                                          item?.DemoCompleteAmount
                                                      ).toFixed(2)}
                                            </td>
                                            <td>
                                                ₹{" "}
                                                {isNaN(
                                                    item?.DemoConversionCredit
                                                )
                                                    ? "NA"
                                                    : Number(
                                                          item?.DemoConversionCredit
                                                      ).toFixed(2)}
                                            </td>
                                            <td>
                                                ₹{" "}
                                                {isNaN(item?.PenaltyCharged)
                                                    ? "NA"
                                                    : Number(
                                                          item?.PenaltyCharged
                                                      ).toFixed(2)}
                                            </td>
                                            <td>
                                                ₹{" "}
                                                {isNaN(item?.PenaltyReversed)
                                                    ? "NA"
                                                    : Number(
                                                          item?.PenaltyReversed
                                                      ).toFixed(2)}
                                            </td>
                                            <td>
                                                ₹{" "}
                                                {isNaN(item?.ManualAdjCredit)
                                                    ? "NA"
                                                    : Number(
                                                          item?.ManualAdjCredit
                                                      ).toFixed(2)}
                                            </td>
                                            <td>
                                                ₹{" "}
                                                {isNaN(item?.ManualAdjDebit)
                                                    ? "NA"
                                                    : Number(
                                                          item?.ManualAdjDebit
                                                      ).toFixed(2)}
                                            </td>
                                            <td>
                                                ₹{" "}
                                                {isNaN(item?.TotalAmount)
                                                    ? "NA"
                                                    : Number(
                                                          item?.TotalAmount
                                                      ).toFixed(2)}
                                            </td>
                                            <td>
                                                ₹{" "}
                                                {isNaN(item?.TDSAmount)
                                                    ? "NA"
                                                    : Number(
                                                          item?.TDSAmount
                                                      ).toFixed(2)}
                                            </td>
                                            <td>
                                                ₹{" "}
                                                {isNaN(item?.AmountToPay)
                                                    ? "NA"
                                                    : Number(
                                                          item?.AmountToPay
                                                      ).toFixed(2)}
                                            </td>
                                            {/*     <td
                                                style={{
                                                    color:
                                                        item.AmountToPay < 0
                                                            ? "red"
                                                            : "green",
                                                }}>
                                                ₹{" "}
                                                {isNaN(item.AmountToPay)
                                                    ? 0.0
                                                    : Math.floor(
                                                          item.AmountToPay * 100
                                                      ) / 100}
                                            </td> */}
                                            <td>
                                                <span
                                                    className={
                                                        item.PayoutStatus === 1
                                                            ? EarningClasses[
                                                                  "paid"
                                                              ]
                                                            : EarningClasses[
                                                                  "unpaid"
                                                              ]
                                                    }>
                                                    {item.PayoutStatus === 1
                                                        ? "paid"
                                                        : "pending"}
                                                </span>{" "}
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td
                                        colSpan={8}
                                        style={{ textAlign: "center" }}>
                                        No Record Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    )}
                </table>
            </div>
        </>
    );
}

export default Earnings;
